import { render } from "./Index.vue?vue&type=template&id=22c71fe8"
const script = {}

import exportComponent from "/var/www/html/aims/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__